import { useEffect, useState } from "react";
import ContactForm from "../components/ContactForm";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Timeline from "../components/Timeline";
import ProductsHeroSection from "../components/ProductsHeroSection";
import SegmentsWeCaterTo from "../components/SegmentWeCater";
import "../styles/Products.scss";
import { useLocation } from "react-router-dom";

interface InformationProps {
  mainText: string;
  info: string;
}

const PhoneWithUPI = `${process.env.REACT_APP_S3_URL}phonewithUPI.svg`;
const PhoneWithIMPS = `${process.env.REACT_APP_S3_URL}IphoneWithIMPS.svg`;
const PhoneWithBBPS = `${process.env.REACT_APP_S3_URL}IphoneWithBBPS.svg`;
const PhoneWithAEPS = `${process.env.REACT_APP_S3_URL}IphoneWithAEPS.svg`;
const Scanner = `${process.env.REACT_APP_S3_URL}Scanner.png`;
const QR = `${process.env.REACT_APP_S3_URL}GenerateQR.png`;
const UPICollect = `${process.env.REACT_APP_S3_URL}g24UPI.png`;
const Payouts = `${process.env.REACT_APP_S3_URL}Payouts.png`;
const P2PTransfer = `${process.env.REACT_APP_S3_URL}P2PFundTransfer.png`;
const BankIcon = `${process.env.REACT_APP_S3_URL}BankIcon.png`;
const Cart = `${process.env.REACT_APP_S3_URL}Cart.png`;
const Wallet = `${process.env.REACT_APP_S3_URL}Wallet.png`;
const BillPay = `${process.env.REACT_APP_S3_URL}BillPay.png`;
const Cash = `${process.env.REACT_APP_S3_URL}Cash.png`;
const IDCard = `${process.env.REACT_APP_S3_URL}IDCard.png`;

const App: React.FC = () => {
  const location = useLocation();
  const [pageConfig, setPageConfig] = useState({
    title: "Digital Payments with UPI",
    description:
      "Powering India's Digital Payment revolution with our UPI Switch & Stack",
    phoneIcon: PhoneWithUPI,
    mainText: "Elevate your Digital Payments ",
    info: "Stack with our UPI solutions. Enjoy effortless API integration, top-notch security & Cloud native scalability designed to meet the evolving needs of your Bank or Fintech",
    hostedHeaderName: "UPI Switch",
    cardsData: [
      {
        icon: Scanner, // or you can use an actual icon component
        title: "Scan & Pay",
        description:
          "Easy Integration For Streamlined And Efficient Operations.",
        isComingSoon: false,
        isSelected: false,
      },
    ],
    segments: [
      {
        number: "01",
        name: "Banks",
        description:
          "Hosted UPI Switch, Merchant Layer, PSP App, Wallet Integration, MIS Portals Recon, Relevant APIs & SDKs",
      },
      {
        number: "02",
        name: "PPI’s",
        description:
          "Hosted UPI Switch, Merchant Layer, PSP App, Wallet Integration, MIS Portals Recon, Relevant APIs & SDKs",
      },
      {
        number: "03",
        name: "TPAP’s",
        description:
          "Hosted UPI Switch, Merchant Layer, PSP App, Wallet Integration, MIS Portals Recon, Relevant APIs & SDKs",
      },
      {
        number: "04",
        name: "Fintechs",
        description:
          "Hosted UPI Switch, Merchant Layer, PSP App, Wallet Integration, MIS Portals Recon, Relevant APIs & SDKs",
      },
    ],
  });

  const GetDetails = () => {
    if (location.pathname === "/products/upi") {
      setPageConfig({
        title: "Seamless UPI Payments Solutions",
        description:
          "Powering India's Digital Payment revolution with our UPI Switch & Stack",
        phoneIcon: PhoneWithUPI,
        mainText: "Elevate your Digital Payments ",
        info: "Stack with our UPI solutions. Enjoy effortless API integration, top-notch security & Cloud native scalability designed to meet the evolving needs of your Bank or Fintech",
        hostedHeaderName: "UPI Switch",
        cardsData: [
          {
            icon: Scanner, // or you can use an actual icon component
            title: "Scan & Pay",
            description:
              "Securely scan QR codes to make instant and hassle-free digital payments.",
            isComingSoon: false,
            isSelected: false,
          },
          {
            icon: QR,
            title: "Generate QR",
            description:
              "Create dynamic and static QR codes for seamless and secure payments.",
            isComingSoon: false,
            isSelected: false,
          },
          {
            icon: UPICollect,
            title: "UPI Collect",
            description:
              "Request payments from customers using UPI Collect feature.",
            isComingSoon: false,
            isSelected: true,
          },
          {
            icon: Payouts,
            title: "UPI Payouts",
            description:
              "Instantly disburse funds to multiple recipients via fast UPI transfers.",
            isComingSoon: false,
            isSelected: false,
          },
          {
            icon: Scanner, // or you can use an actual icon component
            title: "Signed Intent Flow",
            description:
              "Enhanced security with digitally signed UPI transaction requests.",
            isComingSoon: false,
            isSelected: false,
          },
          {
            icon: QR,
            title: "UDIR",
            description:
              "Streamlined dispute resolution for UPI transactions with efficiency.",
            isComingSoon: false,
            isSelected: false,
          },
          {
            icon: UPICollect,
            title: "UPI Auto-Pay",
            description:
              "Enable automated recurring payments using UPI Auto-Pay feature.",
            isComingSoon: false,
            isSelected: true,
          },
          {
            icon: Payouts,
            title: "UPI Lite",
            description:
              "Use a digital wallet for small-value UPI transactions.",
            isComingSoon: false,
            isSelected: false,
          },
          {
            icon: UPICollect,
            title: "UPI International",
            description:
              "Make seamless UPI payments across international merchant networks.",
            isComingSoon: false,
            isSelected: true,
          },
          {
            icon: Payouts,
            title: "Rupay CC on UPI",
            description:
              "Link and seamlessly use RuPay credit cards via UPI with ease.",
            isComingSoon: false,
            isSelected: false,
          },
          {
            icon: QR,
            title: "Credit Line on UPI",
            description:
              "Access pre-approved credit lines through seamless UPI integration.",
            isComingSoon: false,
            isSelected: false,
          },
          // {
          //   icon: UPICollect,
          //   title: "Hello UPI",
          //   description:
          //     "Make UPI payments using voice commands on devices.",
          //   isComingSoon: true,
          //   isSelected: true,
          // },
          // {
          //   icon: Payouts,
          //   title: "UPI 123 Pay",
          //   description:
          //     "Make effortless digital payments via UPI on feature phones without internet.",
          //   isComingSoon: true,
          //   isSelected: false,
          // },
          // {
          //   icon: Payouts,
          //   title: "UPI Lite X: Tap & Pay",
          //   description:
          //     "Use NFC technology to seamlessly make offline UPI payments.",
          //   isComingSoon: true,
          //   isSelected: false,
          // },
        ],
        segments: [
          {
            number: "01",
            name: "Banks",
            description:
              "Hosted UPI Switch, Merchant Layer, PSP App, CBS Integration, MIS Portals Recon, Relevant APIs & SDKs",
          },
          {
            number: "02",
            name: "PPIs",
            description:
              "Hosted UPI Switch, Merchant Layer, PSP App, Wallet Integration, MIS Portals Recon, Relevant APIs & SDKs",
          },
          {
            number: "03",
            name: "TPAPs",
            description:
              "UPI SDK, MIS Portals, Recon",
          },
          {
            number: "04",
            name: "Fintechs",
            description:
              "APIs, SDKs of UPI Stack, MIS Portals",
          },
        ],
      });
    } else if (location.pathname === "/products/imps") {
      console.log("location", location.pathname);
      setPageConfig({
        title: "Instant IMPS Money Transfers",
        description: "Accelerate Real-Time Transactions with Our IMPS Switch",
        phoneIcon: PhoneWithIMPS,
        mainText: "Empower your customers ",
        info: "with lightning-fast money transfers. Our IMPS Switch & Stack offers robust security, easy API integration & cloud-native scalability to grow with your bank or fintech's transaction volume.",
        hostedHeaderName: "IMPS Switch",
        cardsData: [
          {
            icon: P2PTransfer, // or you can use an actual icon component
            title: "P2P Fund Transfer",
            description:
              "Instantly transfer funds between individuals using IMPS securely.",
            isComingSoon: false,
            isSelected: false,
          },
          {
            icon: BankIcon,
            title: "P2A Fund Transfer",
            description:
              "Securely transfer money instantly to bank accounts via IMPS.",
            isComingSoon: false,
            isSelected: false,
          },
          {
            icon: Cart,
            title: "P2M Fund Transfer",
            description:
              "Make instant merchant payments using IMPS infrastructure securely.",
            isComingSoon: false,
            isSelected: true,
          },
          {
            icon: Wallet,
            title: "Balance Enquiry",
            description:
              "Check your account balance instantly using IMPS services.",
            isComingSoon: false,
            isSelected: false,
          },
          {
            icon: P2PTransfer, // or you can use an actual icon component
            title: "Generate OTP",
            description:
              "Secure IMPS transactions with instant OTP generation process.",
            isComingSoon: false,
            isSelected: false,
          },
          {
            icon: BankIcon,
            title: "IMPS Payouts",
            description:
              "Disburse instant payments to beneficiaries via IMPS platform.",
            isComingSoon: false,
            isSelected: false,
          },
          {
            icon: Cart,
            title: "Account Validation via Penny Drop",
            description:
              "Verify bank accounts instantly using Penny Drop method.",
            isComingSoon: false,
            isSelected: true,
          },
          {
            icon: Wallet,
            title: "Bulk Payments via IMPS",
            description:
              "Process multiple payments instantly using IMPS bulk transfers.",
            isComingSoon: true,
            isSelected: false,
          },
          // {
          //   icon: P2PTransfer, // or you can use an actual icon component
          //   title: "Validation Services via IMPS",
          //   description:
          //     "Easy Integration For Streamlined And Efficient Operations.",
          //   isComingSoon: true,
          //   isSelected: false,
          // },
          // {
          //   icon: BankIcon,
          //   title: "IMPS QR Payments",
          //   description:
          //     "Easy Integration For Streamlined And Efficient Operations.",
          //   isComingSoon: true,
          //   isSelected: false,
          // },
          // {
          //   icon: Cart,
          //   title: "Signed Intent Flow",
          //   description:
          //     "Rigorous Adherence To NPCI Standards And Certification Processes.",
          //   isComingSoon: true,
          //   isSelected: true,
          // },
        ],
        segments: [
          {
            number: "01",
            name: "Banks",
            description:
              "Hosted IMPS Switch, CBS Integration, MIS Portals, Recon, Relevant APIs & SDKs",
          },
          {
            number: "02",
            name: "Fintech",
            description:
              "Relevant APIs, MIS Portals, Recon",
          },
        ],
      });
    } else if (location.pathname === "/products/bbps") {
      setPageConfig({
        title: "Bill Payments with BBPS",
        description:
          "Revolutionising Bill Payments with our BBPS Switch & Stack",
        phoneIcon: PhoneWithBBPS,
        mainText: "Offer bill payments via BBPS ",
        info: "to your customers & billers with our intuitive API/SDK integration, ensuring secure and efficient transactions. Experience unmatched flexibility and scalability, designed to grow with your needs.",
        hostedHeaderName: "BBPS Switch",
        cardsData: [
          {
            icon: Scanner, // or you can use an actual icon component
            title: "Agent Onboarding",
            description:
              "Seamlessly onboard agents for secure and efficient bill payments.",
            isComingSoon: false,
            isSelected: false,
          },
          {
            icon: QR,
            title: "Bill Fetch",
            description:
              "Retrieve and display bill details before payment processing.",
            isComingSoon: false,
            isSelected: false,
          },
          {
            icon: BillPay,
            title: "Bill Pay",
            description:
              "Securely pay various bills using the BBPS payment platform.",
            isComingSoon: false,
            isSelected: true,
          },
          {
            icon: BillPay,
            title: "Corporate Bill Payments",
            description:
              "Enable seamless bill payments for corporate entities efficiently.",
            isComingSoon: false,
            isSelected: false,
          },
          {
            icon: Scanner, // or you can use an actual icon component
            title: "Cross Border Payments",
            description:
              "Facilitate international bill payments through BBPS infrastructure.",
            isComingSoon: false,
            isSelected: false,
          },
          {
            icon: QR,
            title: "ClickPay",
            description:
              "Make quick bill payments using pre-generated payment links.",
            isComingSoon: false,
            isSelected: false,
          },
          {
            icon: BillPay,
            title: "UPMS",
            description:
              "Manage biller subscriptions efficiently with Unified Presentment System.",
            isComingSoon: false,
            isSelected: true,
          },
          {
            icon: BillPay,
            title: "MIS/3-Way Recon",
            description:
              "Ensure accurate reconciliation with automated BBPS MIS reports.",
            isComingSoon: false,
            isSelected: false,
          },
        ],
        segments: [
          {
            number: "01",
            name: "Banks (BOU/COU)",
            description:
              "BBPS Switch, Admin/MIS Portal",
          },
          {
            number: "02",
            name: "Non-Banks (BOU/COU)",
            description:
              "BBPS Switch, Admin/MIS Portal",
          },
          {
            number: "03",
            name: "Billers (Biller Aggregator Platform)",
            description:
              "Biller Onboarding",
          },
          {
            number: "04",
            name: "Fintechs",
            description:
              "Agent Institution Onboarding- BBPS SDK",
          },
        ],
      });
    } else if (location.pathname === "/products/aeps") {
      setPageConfig({
        title: "Secure Aadhaar-Enabled Transactions",
        description:
          "Enabling Seamless Banking Access with Our Advanced AePS Solutions",
        phoneIcon: PhoneWithAEPS,
        mainText: "Facilitate secure & convenient ",
        info: "banking services using Aadhaar authentication. Our AePS switch guarantees superior security, smooth integration, and scalable performance, perfect for banks to enable financial inclusion for their customers",
        hostedHeaderName: "AEPS Switch",
        cardsData: [
          {
            icon: Wallet, // or you can use an actual icon component
            title: "Balance Enquiry",
            description:
              "Check bank account balance using Aadhaar authentication.",
            isComingSoon: false,
            isSelected: false,
          },
          {
            icon: Cash,
            title: "Cash Deposit",
            description:
              "Deposit cash into bank accounts via Aadhaar authentication.",
            isComingSoon: false,
            isSelected: false,
          },
          {
            icon: Cash,
            title: "Cash Withdrawal",
            description:
              "Withdraw cash securely using Aadhaar-enabled banking services.",
            isComingSoon: false,
            isSelected: true,
          },
          {
            icon: IDCard,
            title: "Aadhar to Aadhar Fund Transfer",
            description:
              "Transfer funds instantly between Aadhaar-linked bank accounts.",
            isComingSoon: false,
            isSelected: false,
          },
          {
            icon: Cash,
            title: "Mini Statement",
            description:
              "View recent transaction history of Aadhaar-linked accounts.",
            isComingSoon: false,
            isSelected: false,
          },
          {
            icon: Cash,
            title: "UDIR",
            description:
              "Resolve Aadhaar-linked transaction disputes through UDIR framework.",
            isComingSoon: false,
            isSelected: true,
          },
          {
            icon: IDCard,
            title: "e-KYC",
            description:
              "Authenticate customer identity digitally using Aadhaar-based e-KYC.",
            isComingSoon: false,
            isSelected: false,
          },
          {
            icon: IDCard,
            title: "Aadhar Seeding & Linking",
            description:
              "Link Aadhaar with bank accounts for seamless transactions.",
            isComingSoon: false,
            isSelected: false,
          },
        ],
        segments: [
          {
            number: "01",
            name: "Banks",
            description:
              "Hosted UPI Switch, Merchant Layer, PSP App, Wallet Integration, MIS Portals Recon, Relevant APIs & SDKs",
          },
          {
            number: "02",
            name: "Fintech",
            description:
              "Fintech- Relevant APIs, MIS Portals, Recon",
          },
        ],
      });
    }
  };

  useEffect(() => {
    GetDetails();
  }, []);

  const Information: React.FC<InformationProps> = ({ mainText, info }) => {
    return (
      <div className="information-container-p">
        <div className="information-p">
          <h3>
            <span
              style={{
                background:
                  "linear-gradient(81.88deg, #E51A4B 0%, #E36F8A 107.04%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text", // For Firefox
                color: "transparent",
              }}
            >
              {mainText}
            </span>
            {info}
          </h3>
        </div>
      </div>
    );
  };

  return (
    <div>
      <ProductsHeroSection
        title={pageConfig?.title}
        description={pageConfig?.description}
        imageSrc={pageConfig?.phoneIcon}
      />
      <Information mainText={pageConfig?.mainText} info={pageConfig?.info} />
      <Timeline
        hostedHeaderName={pageConfig?.hostedHeaderName}
        cardData={pageConfig?.cardsData}
      />
      <SegmentsWeCaterTo segments={pageConfig?.segments} />
      <ContactForm />
      <Footer />
    </div>
  );
};

export default App;
